import AWSAppSyncClient from "aws-appsync";
import Auth from "@/plugins/aws-amplify";
import store from "../store";
import moment from "moment";

const config = {
  url: process.env.VUE_APP_AWS_APPSYNC_ENDPOINT,
  region: process.env.VUE_APP_AWS_APPSYNC_REGION,
  auth: {
    type: process.env.VUE_APP_AWS_APPSYNC_AUTH_TYPE,
    jwtToken: async () => {
      try {
        const session = await Auth.currentSession();
        // console.log(session, session.isValid());

        if (!session.isValid()) return;
        const idToken = session.getIdToken().getJwtToken();
        if (store.state.user && store.state.user.idToken != idToken) {
          console.log(`appSync토큰을 재발행-- ${moment().format("hh:mm:ss")}`);
          // const accessToken = session.getIdToken().getJwtToken();
          // console.log({ idToken, accessToken });
          const userInfo = store.state.user;
          userInfo.idToken = idToken;
          store.commit("SET_USER", userInfo);
        }
        return idToken;
      } catch (error) {
        // await store.dispatch("signOut");
      }
    }
  },
  disableOffline: true
};
const options = {
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache"
    }
  }
};

const defaultClient = new AWSAppSyncClient(config, options);

export default defaultClient;
